module.exports = __webpack_public_path__ + "img/profile-text-bg.44fb74e2.jpg";